import Axios from '../context/axios/AxiosControl'

export const getCalendars = () => async (dispatch) => {
    dispatch({
        type: 'CALENDAR_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/calendar/getall/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CALENDAR_GETALL_SUCCESS',
                payload: data.calendars
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_NOT_LOADING'
        })
    }
}

export const getCalendarsByRestaurant = (restaurantid) => async (dispatch) => {
    dispatch({
        type: 'CALENDAR_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/calendar/getbyrestaurant/' + restaurantid, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CALENDAR_GETALL_SUCCESS',
                payload: data.calendars
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_NOT_LOADING'
        })
    }
}

export const getCalendarsByDate = (calendarsearch) => async (dispatch) => {
    dispatch({
        type: 'CALENDAR_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/restaurant/calendar/getbydate/', calendarsearch, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CALENDAR_GETALL_SUCCESS',
                payload: data.calendars
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_NOT_LOADING'
        })
    }
}

export const getCalendar = (calendar) => async (dispatch) => {
    dispatch({
        type: 'CALENDAR_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/restaurant/calendar/get/'+ calendar, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'CALENDAR_GET_SUCCESS',
                payload: data.calendar
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_NOT_LOADING'
        })
    }
}

export const addCalendar = (calendardata) => async (dispatch) => {
    dispatch({
        type: 'CALENDAR_LOADING'
    })
    try {
        const { data, status} = await Axios.post('/api/restaurant/calendar/register', calendardata, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'CALENDAR_ADD_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'CALENDAR_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_NOT_LOADING'
        })
    }
}

export const editCalendar = (calendardata, idCalendar) => async (dispatch) => {
    dispatch({
        type: 'CALENDAR_LOADING'
    })
    try {
        const { data, status} = await Axios.put('/api/restaurant/calendar/edit/' + idCalendar, calendardata, {
                headers: {
                    auth: localStorage.getItem('jwt')
                }
            }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'CALENDAR_EDIT_SUCCESS',
                payload: data.message
            })
            dispatch({
                type: 'CALENDAR_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_ERROR'
        })
    }
}

export const removeCalendar = (calendar) => async (dispatch) => {
    try {
        const { data, status } = await Axios.delete('/api/restaurant/calendar/remove/' + calendar, {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 263) {
            dispatch({
                type: 'CALENDAR_REMOVE_RESULT',
                payload: data
            })
            dispatch({
                type: 'CALENDAR_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CALENDAR_NOT_LOADING'
        })
    }
}